/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/trustedNetworkOperationsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a TrustedNetworkOperations. */
export class TrustedNetworkOperations {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a TrustedNetworkOperations.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Retrieves all trusted networks for for the current user.
   * @summary Retrieves all trusted networks for for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.TrustedNetworkGetTrustedNetworksResponse>
   */
  getTrustedNetworks(options?: coreHttp.RequestOptionsBase): Promise<Models.TrustedNetworkGetTrustedNetworksResponse>;
  /**
   * @param callback The callback
   */
  getTrustedNetworks(callback: coreHttp.ServiceCallback<Models.TrustedNetwork[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getTrustedNetworks(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.TrustedNetwork[]>): void;
  getTrustedNetworks(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.TrustedNetwork[]>, callback?: coreHttp.ServiceCallback<Models.TrustedNetwork[]>): Promise<Models.TrustedNetworkGetTrustedNetworksResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getTrustedNetworksOperationSpec,
      callback) as Promise<Models.TrustedNetworkGetTrustedNetworksResponse>;
  }

  /**
   * Creates a new trusted network.
   * @summary Creates a new trusted network.
   * @param [options] The optional parameters
   * @returns Promise<Models.TrustedNetworkCreateTrustedNetworkResponse>
   */
  createTrustedNetwork(options?: Models.TrustedNetworkCreateTrustedNetworkOptionalParams): Promise<Models.TrustedNetworkCreateTrustedNetworkResponse>;
  /**
   * @param callback The callback
   */
  createTrustedNetwork(callback: coreHttp.ServiceCallback<Models.TrustedNetwork>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  createTrustedNetwork(options: Models.TrustedNetworkCreateTrustedNetworkOptionalParams, callback: coreHttp.ServiceCallback<Models.TrustedNetwork>): void;
  createTrustedNetwork(options?: Models.TrustedNetworkCreateTrustedNetworkOptionalParams | coreHttp.ServiceCallback<Models.TrustedNetwork>, callback?: coreHttp.ServiceCallback<Models.TrustedNetwork>): Promise<Models.TrustedNetworkCreateTrustedNetworkResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      createTrustedNetworkOperationSpec,
      callback) as Promise<Models.TrustedNetworkCreateTrustedNetworkResponse>;
  }

  /**
   * Depricated API due to the Batch add trusted networks.
   * @summary Batch add trusted networks.
   * @param [options] The optional parameters
   * @returns Promise<Models.TrustedNetworkCreateTrustedNetworksResponse>
   */
  createTrustedNetworks(options?: Models.TrustedNetworkCreateTrustedNetworksOptionalParams): Promise<Models.TrustedNetworkCreateTrustedNetworksResponse>;
  /**
   * @param callback The callback
   */
  createTrustedNetworks(callback: coreHttp.ServiceCallback<Models.TrustedNetwork[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  createTrustedNetworks(options: Models.TrustedNetworkCreateTrustedNetworksOptionalParams, callback: coreHttp.ServiceCallback<Models.TrustedNetwork[]>): void;
  createTrustedNetworks(options?: Models.TrustedNetworkCreateTrustedNetworksOptionalParams | coreHttp.ServiceCallback<Models.TrustedNetwork[]>, callback?: coreHttp.ServiceCallback<Models.TrustedNetwork[]>): Promise<Models.TrustedNetworkCreateTrustedNetworksResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      createTrustedNetworksOperationSpec,
      callback) as Promise<Models.TrustedNetworkCreateTrustedNetworksResponse>;
  }

  /**
   * Updates a trusted network by ID. Note that if verdict in request has lower priority than the
   * current verdict, the trusted network will not be updated.
   * @summary Updates a trusted network by ID.
   * @param trustedNetworkId
   * @param [options] The optional parameters
   * @returns Promise<Models.TrustedNetworkPatchTrustedNetworkResponse>
   */
  patchTrustedNetwork(trustedNetworkId: string, options?: Models.TrustedNetworkPatchTrustedNetworkOptionalParams): Promise<Models.TrustedNetworkPatchTrustedNetworkResponse>;
  /**
   * @param trustedNetworkId
   * @param callback The callback
   */
  patchTrustedNetwork(trustedNetworkId: string, callback: coreHttp.ServiceCallback<Models.TrustedNetwork>): void;
  /**
   * @param trustedNetworkId
   * @param options The optional parameters
   * @param callback The callback
   */
  patchTrustedNetwork(trustedNetworkId: string, options: Models.TrustedNetworkPatchTrustedNetworkOptionalParams, callback: coreHttp.ServiceCallback<Models.TrustedNetwork>): void;
  patchTrustedNetwork(trustedNetworkId: string, options?: Models.TrustedNetworkPatchTrustedNetworkOptionalParams | coreHttp.ServiceCallback<Models.TrustedNetwork>, callback?: coreHttp.ServiceCallback<Models.TrustedNetwork>): Promise<Models.TrustedNetworkPatchTrustedNetworkResponse> {
    return this.client.sendOperationRequest(
      {
        trustedNetworkId,
        options
      },
      patchTrustedNetworkOperationSpec,
      callback) as Promise<Models.TrustedNetworkPatchTrustedNetworkResponse>;
  }

  /**
   * Deletes a trusted network by ID.
   * @summary Deletes a trusted network by ID.
   * @param trustedNetworkId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteTrustedNetwork(trustedNetworkId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param trustedNetworkId
   * @param callback The callback
   */
  deleteTrustedNetwork(trustedNetworkId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param trustedNetworkId
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteTrustedNetwork(trustedNetworkId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteTrustedNetwork(trustedNetworkId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        trustedNetworkId,
        options
      },
      deleteTrustedNetworkOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getTrustedNetworksOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Vpn/TrustedNetwork",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TrustedNetwork"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const createTrustedNetworkOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/Vpn/TrustedNetwork",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.NewTrustedNetworkRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.TrustedNetwork
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const createTrustedNetworksOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/Vpn/TrustedNetwork",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: {
      serializedName: "body",
      type: {
        name: "Sequence",
        element: {
          type: {
            name: "Composite",
            className: "NewTrustedNetworkRequest"
          }
        }
      }
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TrustedNetwork"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const patchTrustedNetworkOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/Vpn/TrustedNetwork/{trustedNetworkId}",
  urlParameters: [
    Parameters.trustedNetworkId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateTrustedNetworkRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.TrustedNetwork
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteTrustedNetworkOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/me/Vpn/TrustedNetwork/{trustedNetworkId}",
  urlParameters: [
    Parameters.trustedNetworkId
  ],
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
